/**
 * Contact person dropdown module.
 * Loads users for a selected agency and populates a dependent dropdown.
 */

import { fetchJson } from '../lib/api-client';

export interface ContactDropdownOptions {
    agencySelect: HTMLSelectElement;
    containerElementId: string;
    getUsersUrl: string;
    preselectedContactId?: string;
    preselectedAgencyId?: string;
}

/**
 * Setup agency → contact person cascading dropdown
 */
export function setupContactPersonDropdown(options: ContactDropdownOptions) {
    const { agencySelect, containerElementId, getUsersUrl, preselectedContactId, preselectedAgencyId } = options;

    // Load contact persons on page load if agency is already selected
    if (preselectedAgencyId) {
        loadContactPersons(preselectedAgencyId, preselectedContactId);
    }

    agencySelect.addEventListener('change', function () {
        loadContactPersons(this.value);
    });

    async function loadContactPersons(agencyId: string, selectedId?: string) {
        if (!agencyId) return;

        try {
            const data = await fetchJson<Array<{ value: string; text: string }>>(`${getUsersUrl}?agencyId=${agencyId}`);
            renderContactDropdown(data, selectedId);
        } catch (error) {
            console.error('Failed to load contact persons:', error);
        }
    }

    function renderContactDropdown(users: Array<{ value: string; text: string }>, selectedId?: string) {
        const container = document.getElementById(containerElementId);
        if (!container) return;

        let options = '<option value=""></option>';
        users.forEach((item) => {
            const selected = selectedId && item.value === selectedId ? ' selected' : '';
            options += `<option value="${item.value}"${selected}>${item.text}</option>`;
        });

        container.innerHTML = `<select class="form-select" id="ContactPersonId" name="ContactPersonId">${options}</select>`;
    }
}
